/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

import SequenceSearchView from 'components/SequenceSearchView';

class LibrarySearchResults extends Backbone.Collection {
  static initClass() {
    this.prototype.url = '/1/api/minimal-folders';
  }
}
LibrarySearchResults.initClass();

class SequenceAndLibrarySearchView extends SequenceSearchView {
  initialize(options) {
    super.initialize(options);
    ({selectLibrary: this.selectLibrary, libraryType: this.libraryType} = options);
    this.libraryResults = new LibrarySearchResults();
  }

  updateSearchResults() {
    // Overrides super
    this.hideSpinner();
    this.$('.search-results').empty();
    if (this.libraryResults.length + this.sequenceResults.length === 0) {
      this.showNoResultsMessage();
      return;
    }
    const $libEls = this.libraryResults.map((library) =>
      $(
        this.resultRowTemplate({
          name: this._getLibraryLabel(library),
          path: library.get('owner_handle'),
        })
      )
        .data('result', library)
        .data('result_type', 'library')
    );
    this.$('.search-results').append($libEls);
    const $seqEls = this.sequenceResults.map((sequence) =>
      $(
        this.resultRowTemplate({
          name: sequence.get('name'),
          path: this._getSequencePath(sequence),
        })
      )
        .data('result', sequence)
        .data('result_type', 'sequence')
    );
    this.$('.search-results').append($seqEls);
    this.$('.search-results').show();
  }

  _getLibraryLabel(library) {
    return `${library.get('name')} (folder)`;
  }

  fetchResults(query) {
    const data = {query};
    if (this.libraryType) {
      data.type = this.libraryType;
    }
    const libXHR = this.libraryResults.fetch({data});
    const seqXHR = this.sequenceResults.fetch({data: {q: query}});
    return [libXHR, seqXHR];
  }

  selectResult($target) {
    // Overrides super
    const targetType = $target.data('result_type');
    const targetModel = $target.data('result');
    if (this.clearSearchAfterClick) {
      this.clearSearch();
    }
    if (targetType === 'sequence') {
      this.selectSequence(targetModel);
      return;
    }
    if (targetType === 'library') {
      this.selectLibrary(targetModel);
    }
  }

  render() {
    this.$el.html(this.template({searchLibrary: true}));
    if (this.alwaysDisplayResults) {
      this.showNoResultsMessage();
    }
    return this;
  }
}

export default SequenceAndLibrarySearchView;
